const n8nChatbotDictIT = {
  // Interface texts
  chatTitle: "Chat Extraconomy",
  chatTitleDev: "Chat Extraconomy (Modalità Dev)",
  statusOnline: "Online",
  statusOffline: "Offline",
  statusChecking: "Controllo...",
  statusDevMode: "Modalità Dev",
  placeholder: "Scrivi il tuo messaggio...",
  tooltip: "Contattaci!",

  // Welcome message
  welcomeMessage: "Ciao! Sono l'assistente virtuale di Extraconomy. Come posso aiutarti oggi?",

  // Loading states
  typing: "Digitando...",

  // Error messages
  errorGeneric: "Spiacenti, sto avendo difficoltà tecniche al momento. Contattaci a: support@extraconomy.com",
  errorWithDetails: "Spiacenti, sto avendo difficoltà tecniche al momento. Contattaci a: support@extraconomy.com\n\nErrore: {error}",

  // Fallback responses
  fallbackResponse: "Grazie per il tuo messaggio! Sono qui per aiutare con informazioni su Extraconomy. Puoi chiedere di registrazione, piani, funzionalità o qualsiasi altra domanda!"
};

export default n8nChatbotDictIT;
